export const updateSelectedFilter = filters => filtersSelected => {
  filters.forEach(f => {
    const isFilter = filtersSelected.find(fs => fs.value === f.value);
    if (isFilter === undefined && f.value !== 'CustomFilter') {
      // eslint-disable-next-line no-param-reassign
      filters = filters.filter(filter => filter.value !== f.value);
    }
  });

  filtersSelected.forEach(fs => {
    const isFilter = filters.find(f => f.value === fs.value);
    if (isFilter === undefined) {
      filters.push(fs);
    }
  });
  return filters;
};
